import React from 'react';
import styled from 'styled-components/macro';

import CreditCardDetails from 'components/CreditCardDetails';
import {
  CreditCardDetailsInputLabel,
  CreditCardDetailsInputWrapper,
  CreditCardDetailsWrapper,
} from 'components/CreditCardDetails/styles';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { TRIAL_COLORS } from 'screens/Trials/styles';

export const TrialPaymentForm = () => {
  const { isSubmittingTrial } = useTrialsContext() || {};

  return (
    <TrialPaymentFormWrapper>
      <CreditCardDetails
        loading={isSubmittingTrial}
        headerText=""
        trackOnBlurPath="trials.startTrial"
        zipCodeLabel="ZIP Code"
      />
    </TrialPaymentFormWrapper>
  );
};

const TrialPaymentFormWrapper = styled.div`
  ${CreditCardDetailsWrapper} {
    margin-top: 0;
  }

  ${CreditCardDetailsInputWrapper} {
    input,
    .StripeElement {
      border-radius: 10px;
    }
  }

  ${CreditCardDetailsInputLabel} {
    color: ${TRIAL_COLORS.darkText};
  }
`;

export default TrialPaymentForm;
